module.exports = __webpack_public_path__ + "img/carousel-photo02.a3769fa0.jpg";